<template>
  <div>
    <Header></Header>
    <!-- 轮播图 -->
    <!-- <div class='banner'>
      <img src='../assets/img/index/banner.jpg' alt=''>
    </div> -->
    <div>
     <el-carousel height="543px">
       <el-carousel-item>
          <div class="headerBanner1"></div>
          <!-- <img src='../assets/img/index/banner.jpg' alt='' style="display: block;"> -->
        </el-carousel-item>
       <el-carousel-item>
          <div class="headerBanner" @click="warningLinkFun"></div>
        </el-carousel-item>
       
    </el-carousel>
    </div>
    <!-- 轮播图 -->
    <div style='text-align: center'><img src='../assets/img/index/map.jpg' alt=''></div>
    <div class='ps'><span>加盟代理实时查询系统PS</span></div>
    <div class='ps-img'><img src='../assets/img/index/ps-agent.jpg' alt=''></div>
    <div class='location'>
      <div class='ing'><span>鲨鱼公园全国城市校区</span></div>
      <div class='city'>
        <div class='city-top'>
          <div class="city-cen">
              <p><span class='dot'>■</span><span class='dot-city'>北京</span>&nbsp;&nbsp;&nbsp;
<!--              <div class="new-city" style="margin-top: -2.5rem;">-->
                <span v-for="(item, index) in region.北京" :key="index"><a style="color:#949494" :href="'https://www.sharkpark.cn/shark/centersInfo/sid/'+item.region_id+'#Map'+item.region_id">{{item.region_name}}</a>&nbsp;&nbsp;&nbsp;</span>
<!--              </div>-->
              </p>
          </div>
          <div class='city-cen'>
            <p><span class='dot'>■</span><span class='dot-city'>上海</span>&nbsp;&nbsp;&nbsp;
<!--            <div class="new-city" style="margin-top: -2.5rem;">-->
              <span v-for="(item, index) in region.上海" :key="index"><a style="color:#949494" :href="'https://www.sharkpark.cn/shark/centersInfo/sid/'+item.region_id+'#Map'+item.region_id">{{item.region_name}}</a>&nbsp;&nbsp;&nbsp;</span>
<!--            </div>-->
            </p>
          </div>
          <div class='city-cen'>
            <p><span class='dot'>■</span><span class='dot-city'>广州</span>&nbsp;&nbsp;&nbsp;
<!--            <div class="new-city" style="margin-top: -2.5rem;">-->
              <span v-for="(item, index) in region.广州" :key="index"><a style="color:#949494" :href="'https://www.sharkpark.cn/shark/centersInfo/sid/'+item.region_id+'#Map'+item.region_id">{{item.region_name}}</a>&nbsp;&nbsp;&nbsp;</span>
<!--            </div>-->
            </p>
          </div>
          <div class='city-cen'>
            <p><span class='dot'>■</span><span class='dot-city'>港澳台</span>&nbsp;&nbsp;&nbsp;
<!--            <div class="new-city" style="margin-top: -2.5rem;">-->
              <span v-for="(item, index) in region.港澳台" :key="index"><a style="color:#949494" :href="'https://www.sharkpark.cn/shark/centersInfo/sid/'+item.region_id+'#Map'+item.region_id">{{item.region_name}}</a>&nbsp;&nbsp;&nbsp;</span>
<!--            </div>-->
            </p>
          </div>
          <div class='city-cen'>
            <p><span class='dot'>■</span><span class='dot-city'>海外</span>&nbsp;&nbsp;&nbsp;
<!--            <div class="new-city" style="margin-top: -2.5rem;">-->
              <span v-for="(item, index) in region.海外" :key="index"><a style="color:#949494" :href="'https://www.sharkpark.cn/shark/centersInfo/sid/'+item.region_id+'#Map'+item.region_id">{{item.region_name}}</a>&nbsp;&nbsp;&nbsp;</span>
<!--            </div>-->
            </p>
          </div>
        </div>
        <div class='city-bottom'>
          <div class='city-left'>
            <div class="city-cen">
              <div><p><span class='dot'>■</span><span class='dot-city'>华北</span></p></div>
              <div class="new-city">
                <span v-for="(item, index) in region.华北" :key="index"><a style="color:#949494" :href="'https://www.sharkpark.cn/shark/centersInfo/sid/'+item.region_id+'#Map'+item.region_id">{{item.region_name}}</a></span>
              </div>
            </div>
            <div class="city-cen">
              <div><p><span class='dot'>■</span><span class='dot-city'>中南</span></p></div>
              <div class="new-city">
                <span v-for="(item, index) in region.中南" :key="index"><a style="color:#949494" :href="'https://www.sharkpark.cn/shark/centersInfo/sid/'+item.region_id+'#Map'+item.region_id">{{item.region_name}}</a></span>
              </div>
            </div>
            <div class="city-cen">
              <div><p><span class='dot'>■</span><span class='dot-city'>东北</span></p></div>
              <div class="new-city">
                <span v-for="(item, index) in region.东北" :key="index"><a style="color:#949494" :href="'https://www.sharkpark.cn/shark/centersInfo/sid/'+item.region_id+'#Map'+item.region_id">{{item.region_name}}</a></span>
              </div>
            </div>
            <div class="city-cen">
              <div><p><span class='dot'>■</span><span class='dot-city'>西北</span></p></div>
              <div class="new-city">
                <span v-for="(item, index) in region.西北" :key="index"><a style="color:#949494" :href="'https://www.sharkpark.cn/shark/centersInfo/sid/'+item.region_id+'#Map'+item.region_id">{{item.region_name}}</a></span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </div>
            </div>
          </div>
          <div class='city-right'>
            <div class="city-cen">
              <div><p><span class='dot'>■</span><span class='dot-city'>华南</span></p></div>
              <div class="new-city">
                <span v-for="(item, index) in region.华南" :key="index"><a style="color:#949494" :href="'https://www.sharkpark.cn/shark/centersInfo/sid/'+item.region_id+'#Map'+item.region_id">{{item.region_name}}</a></span>
              </div>
            </div>
            <div class="city-cen">
              <div><p><span class='dot'>■</span><span class='dot-city'>西南</span></p></div>
              <div class="new-city">
                <span v-for="(item, index) in region.西南" :key="index"><a style="color:#949494" :href="'https://www.sharkpark.cn/shark/centersInfo/sid/'+item.region_id+'#Map'+item.region_id">{{item.region_name}}</a></span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </div>
            </div>
            <div class="city-cen">
              <div><p><span class='dot'>■</span><span class='dot-city'>华东</span></p></div>
              <div class="new-city">
                <span v-for="(item, index) in region.华东" :key="index"><a style="color:#949494" :href="'https://www.sharkpark.cn/shark/centersInfo/sid/'+item.region_id+'#Map'+item.region_id">{{item.region_name}}</a></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class='img'><br><br></div>
   <!--  <div class="warning" style="text-align: center">
      <img src='../assets/img/index/warning.jpg' alt='' style="width: 1200px;cursor: pointer;" @click="warningLinkFun">
    </div> -->
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import axios from 'axios'

export default {
  name: 'Index',
  components: {Header, Footer},
  data () {
    return {
      msg: 'index',
      region: []
    }
  },
  mounted () {
    this.getRegion()
  },
  methods: {
    warningLinkFun(){
    	this.$router.push({
    		path:'/Warning'
    	})
    },  
    getRegion: function () {
      var self = this
      var url = 'https://api.sharkpark.cn/region/Region/GetRegionList'
      // var url = 'http://devapi.sharkpark.cn/region/Region/GetRegionList'
      axios.get(url).then(function (response) {
        // console.log(response.data.data)
        self.region = response.data.data
        // console.log(self.region)
      }).catch(function (error) {
        console.log(error)
        console.log("接口错误")
      })
    }
  }
}
</script>

<style>
  .banner {
    width: 100%;
    height: auto;
  }

  .banner img {
    width: 100%;
  }
  .headerBanner {
    height: 548px;

    /*background: url('../assets/img/warning/banner02.jpg') no-repeat center;*/
    background: url('https://img.stem.cn/online/to_join/1.jpg') no-repeat center;
    background-color: #f92146;
    cursor: pointer;
  }
  .headerBanner1 {
    height: 548px;
    background: url('../assets/img/index/banner.jpg') no-repeat center;
    background-color: #f92146;
    cursor: pointer;
  }
  .ps {
    width: 100%;
    height: 5em;
    line-height: 5em;
    text-align: center;
    background: #00A0E9;
  }

  .ps span {
    color: white;
    font-size: 1.5em;
  }

  .ps-img {
    text-align: center;
    margin-top: 2em;
  }

  .location {
    width: 80%;
    height: auto;
    margin: 0 auto;
    text-align: center;
    color: #767D85;
  }

  .footer {
    background: #464646;
    text-align: center;
  }

  .ing {
    width: 80%;
    height: auto;
    margin: 0 auto;
    text-align: center;
    margin-top: 2em;
  }

  .ing span {
    font-size: 2em;
    color: #00A0E9;
  }

  .city {
    width: 80%;
    height: auto;
    margin: 0 auto;
    /*font-size: 1.3em;*/
    /*font-weight: bold;*/
    text-align: left;
    color: #A8A8A8;
  }

  .city-top {
    /*width: 90%;*/
    height: auto;
    border-bottom: 0.1em #B79E99 dashed;
    padding-bottom:1.5rem;
  }

  .city-bottom {
    /*width:80%;*/
    height: auto;
    margin: 0 auto;
    text-align: left;
  }

  .city-left {
    width: 45%;
    height: auto;
    float: left;
    text-align: left;
  }

  .city-right {
    width: 50%;
    height: auto;
    float: left;
    margin-left: 3%;
  }

  .dot {
    /*font-size: 1.3em;*/
    margin-right: 0.3em;
    font-weight: bold;
    color:#CCCCCC;
  }

  .dot-city {
    font-size: 1.3em;
    color:#585858;
    font-weight: bold;
  }

  .img {
    clear: both;
  }
  .city-cen{
    margin-top:2rem;

  }
  .new-city{
    display:inline-block;
    margin-left:5rem;
    margin-top:-2.0rem;
    line-height: 2rem;
    color:#949494;
    vertical-align: top;
  }
  .new-city span{
    padding-left:1rem;
  }
</style>
